module.exports = {
    nullTips: '用户名和密码不能为空',
    userName: '用户名',
    userLoginAcc: '账号（ID）',
    password: '密码',
    login: '登录',
    veriCode: '验证码',
    inputCodeTips: '请输入验证码',
    clickToRefresh: '点击刷新',
    INVALID_VERI_CODE: '验证码不正确',
    INVALID_USER_OR_PWD: '用户名或密码不正确',
    loginDevTips: '当前为预览模式',
    loginException: '[Dev Error] 登录异常。请确保网络正常可用。打开浏览器控制台，查看错误细节，并联系管理员。',
    BEFORE_LOGIN_SYNTAX_ERR: '[Dev Error] 登录前校验函数有语法错误，原因：',
    LOGIN_SYNTAX_ERR: '[Dev Error] 登录校验函数有语法错误，原因：',
    AFTER_LOGIN_SYNTAX_ERR: '[Dev Error] 登录后函数有语法错误，原因：',
    BEFORE_LOGIN_ERROR: '[Dev Error] 执行登录前函数发生错误，原因：',
    LOGIN_ERROR: '[Dev Error] 执行登录校验函数时发生错误，原因：',
    AFTER_LOGIN_ERROR: '[Dev Error] 执行登录后校验函数时发生错误，原因：',
    beforeLoginScriptError: '[Dev Error] 登录前事件脚本有错误：{{reason}}',
    exeBeforeLoginScriptError: '[Dev Error] 执行登录前时间脚本发生错误：{{reason}}'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.zh-cn.js
// module id = 31
// module chunks = 2